import { faPen } from '@fortawesome/pro-solid-svg-icons'
import { BasicEmptyState, EmptyStateWithAction } from '@scoir/empty-state'

type HighlightsEmptyStateProps = {
  canManageContent: boolean
  handleModal: () => void
}
const HighlightsEmptyState = ({ canManageContent, handleModal }: HighlightsEmptyStateProps) => {
  return canManageContent ? (
    <EmptyStateWithAction
      title="Share your highlights"
      subTitle="Add 5 short sentences that capture what makes your institution special. Your highlights will appear on your profile, giving students and supporters a quick glimpse into what sets you apart."
      icon={faPen}
      actionProps={{
        children: 'Add Highlights',
        onClick: handleModal,
      }}
    />
  ) : (
    <BasicEmptyState
      title="You don’t have permission to add school highlights"
      subTitle="Contact your school’s administrator to grant you the appropriate access."
      icon={faPen}
    />
  )
}

export default HighlightsEmptyState
